<template>
  <div ref="main" class="main">
    <div class="content">
      <div class="top">
        <div class="image"></div>
      </div>
      <div class="footer">
        <p class="nodata">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {
    let windowHeight = document.documentElement.clientHeight
    this.$refs.main.style.height = 467 + 'px'
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.main {
  // height: 667px;
  background-color: #f4f7f9;
  text-align: center;

  .content {
    height: 100%;

    .top {
      width: 200px;
      height: 200px;
      padding: 15px;
      position: relative;
      top: 40px;
      left: 50%;
      margin-left: -100px;
      text-align: center;
      // border: 1px dashed #4e4d4d;

      .image {
        width: 100%;
        height: 100%;
        background: url("../../assets/img/img_toupiao_nodata.png") no-repeat;
        background-size: 100% 100%;

        // border: 1px dashed #4e4d4d;
      }

      .nadata {
        margin-top: 20px;
        font-size: 14px !important;
        font-weight: 400 !important;
        color: #4e4d4d !important;
      }
    }

    .footer {
      width: 100%;
      height: 33px;
      margin-top: 56px;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: #4e4d4d !important;
    }
  }
}

/deep/.van-tab__pane {
  height: 667px;
}
</style>
